const MetiProductsIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25706)" />
      <path
        d="M38.3805 46.4522C38.3805 40.8587 42.9631 36.3435 48.5566 36.3435V24.6848C48.5566 23.7413 47.8153 23 46.8718 23H38.4479V33.1087L35.0784 30.8848L31.7088 33.1087V23H23.2849C22.3414 23 21.6001 23.7413 21.6001 24.6848V44.9022C21.6001 45.8457 22.3414 46.587 23.2849 46.587H38.3805C38.3805 46.5196 38.3805 46.5196 38.3805 46.4522Z"
        fill="white"
      />
      <path
        d="M48.4892 39.2412C44.4457 39.2412 41.0762 42.5434 41.0762 46.5869C41.0762 50.6977 44.3783 53.9999 48.4218 53.9999C52.5327 53.9999 55.8349 50.6977 55.8349 46.6543C55.8349 42.5434 52.5327 39.2412 48.4892 39.2412ZM51.6566 49.4847H50.174V46.2499L49.0283 48.339H47.8827L46.737 46.2499V49.4847H45.2544V43.689H46.8044L48.4218 46.7216L50.0392 43.689H51.5892V49.4847H51.6566Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25706"
          x1="-1.25903e-06"
          y1="-0.0771476"
          x2="70"
          y2="69.9229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B93255" />
          <stop offset="1" stop-color="#8C1433" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MetiProductsIconSubcategory
